export default {"src":"/_next/static/media/logo-konstanz.0204a2f7.svg","height":85,"width":198,"blurWidth":0,"blurHeight":0};